// src/api/client.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// 요청 인터셉터: Authorization 자동 주입
api.interceptors.request.use(
  (config) => {
    const accessToken = sessionStorage.getItem('access_token');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터: 401 처리 + 에러 메시지 정규화
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('refresh_token');
      sessionStorage.removeItem('user_role');
      // ProtectedRoute/AppHeader의 세션 캐시도 함께 정리해서 다음 로그인 시 stale을 막는다
      sessionStorage.removeItem('onboarding_resolved');
      sessionStorage.removeItem('header_profile_cache');
      sessionStorage.removeItem('privacy_consent_resolved');
      window.location.href = '/login';
    }
    const data = error.response?.data;
    const errorCode =
      (data && typeof data === 'object' && (data.error_code || data.detail?.error_code)) || null;

    const ERROR_CODE_MESSAGES = {
      INSUFFICIENT_TOKENS: '토큰 잔액이 부족합니다.',
    };

    let normalized = ERROR_CODE_MESSAGES[errorCode];
    if (!normalized) {
      const rawDetail = data?.detail;
      const detailMessage =
        typeof rawDetail === 'string'
          ? rawDetail
          : rawDetail && typeof rawDetail === 'object'
            ? rawDetail.message || rawDetail.detail
            : null;
      normalized =
        data?.message ||
        detailMessage ||
        error.message ||
        '요청 처리 중 오류가 발생했습니다.';
    }

    error.errorCode = errorCode;
    error.normalizedMessage = normalized;
    return Promise.reject(error);
  }
);

export default api;
